import { defaultButtonProps } from "../../common/components/buttons/sxprops";

export const mainCont = {
  width: "100%",
  height: `100%`,
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  paddingX: "10px",
};

export const actions = {
  mt: "24px",
  width: "100%",
  alignItems: "center",
};

export const addButton = (isMobile: boolean) => ({
  ...defaultButtonProps,
  overflow: "hidden",
  whiteSpace: "nowrap",
  height: "44px",
});

export const imageCell = {
  width: "47px",
  height: "47px",
  borderRadius: "50%",
  overflow: "hidden",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const paginationCont = {
  boxShadow:
    "0px 8px 12px rgba(0, 0, 0, 0.1), 0px 0px 24px rgba(0, 0, 0, 0.08)",
  height: "44px",
  width: "100%",
  marginTop: "10px",
  borderBottomRightRadius: "12px",
  borderBottomLeftRadius: "12px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
};

export const emptyCont = {
  height: "400px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const facilityCont = {
  width: "100%",
  marginBottom: "20px",
  padding: "20px",
  border: "1px solid #6D87AA",
  borderRadius: "10px",
};

export const roleCont = {
  mx: "2px",
  padding: "5px 15px",
  border: "1px solid grey",
  borderRadius: "50px",
  display: "inline-block",
  textAlign: "center",
  marginBottom: "2px",
};

export const modalContentCont = (isLaptopAndUp: boolean) => ({
  borderRadius: "8px",
  padding: "8px",
  minWidth: isLaptopAndUp ? "700px" : "400px",
  border: "3px solid var(--Colors-old-app-bg, rgba(242, 245, 251, 1))",
});

export const formGridSize = {
  mobile: 12,
  tablet: 12,
  laptop: 6,
};
